import React from "react";
import { createElement } from "react";
import { Layout, Dropdown, Avatar, MenuProps } from "antd";

import { useEffect, useState } from "react";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
// import { ErrorResult } from '../ErrorResult.component'
import { ACCOUNT_ID, logoutUrl, SIDER_TITLE } from "../../constants";
// import { isUserLoggedIn } from 'src/utils'
import { LeftMenu } from "./LeftMenu.component";
import { CustomBreadcrumb } from "./CustomBreadcrumb.component";
import { getAvatarInitials } from "../../utils/avatar";
import { useMsal } from "@azure/msal-react";

import "../../MuseDashboard.css";

const { Header, Sider, Content } = Layout;


export const MainLayout = (props: any) => {
  const { instance, accounts } = useMsal();
  const [givenName, setGivenName] = useState("Software Asset Management");


  useEffect(() => {
    if (accounts.length > 0) {
      setGivenName(accounts[0].name);
    }
  }, [accounts]);

  function signOutClickHandler(instance) {
    const logoutRequest = {
      account: instance.getAccountByHomeId(ACCOUNT_ID),
      postLogoutRedirectUri: logoutUrl,
    };
    instance.logoutRedirect(logoutRequest);
  }

  const userDropdownItems: MenuProps["items"] = [
    {
      key: "1",
      label: "Log Out",
      icon: <LogoutOutlined />,
    },
  ];

  const onClick: MenuProps["onClick"] = () => {
    console.log("Logout Requested");
    signOutClickHandler(instance);
  };

  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout>
      <Sider
        theme="light"
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={260}
        style={{
          position: "sticky",
          top: 0,
          left: 0,
          height: "100vh",
          boxShadow: "0 4px 15px #00000008",
        }}
      >
        <div className={"portalTitleCtn"}>
          {createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
            onClick: () => setCollapsed(!collapsed),
            className: "collapseBtn",
            style: {},
          })}
          {!collapsed && (
            <h1 className={"portalTitle"} style={{}}>
              {SIDER_TITLE}
            </h1>
          )}
        </div>
        <LeftMenu />
      </Sider>

      <Layout className="layout">
        <Header className="header">
          <img
            src="/images/irdeto-logo.png"
            alt="irdeto"
            width={132}
            height={40}
          />
          <CustomBreadcrumb />
          <Dropdown menu={{ items: userDropdownItems, onClick }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                marginLeft: "auto",
                gap: "1.5rem",
              }}
            >
       <span className="username">Welcome {givenName}!</span>
<Avatar
  size={40}
  style={{
    margin: "0.5rem 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  {getAvatarInitials(givenName)}
</Avatar>
            </div>
          </Dropdown>
        </Header>
        <Content className="content" style={{ padding: "0 0 2rem" }}>
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};
